/* Delivery estimate (asset externo; ver snippets/delivery-estimate.liquid).
   Prioridad:
     0. data-ask="1" -> proveedor sin fuente de stock y que no fabrica bajo pedido: no hay plazo
        firme que ensenar, el propio Liquid ya pinta el enlace de WhatsApp. Aqui solo se traduce
        el bucket y se coloca el bloque.
     1. data-date  -> fecha REAL que nos compromete el proveedor, formateada en el idioma del visitante.
     2. sin fecha y con stock -> estimacion: FINAL de la horquilla del bucket de envio
        ("1-2 semanas" -> hoy + 14 dias); sin horquilla, hoy + N dias laborables.
     3. sin fecha y sin stock -> ventana del bucket (custom.tiempo_de_envio), traducida.

   30-07-2026: antes el caso 1 no existia y SIEMPRE se usaba el 2, incluso teniendo la fecha
   del proveedor -> prometiamos ~1 semana antes de lo comprometido. Ademas `inStock` venia del
   texto del bucket y no del stock real, asi que un producto agotado seguia anunciando fecha.

   07-08-2026: el plazo ya NO se mueve al lado del precio. Va donde el snippet ya se pinta por
   Liquid: en la linea de entrega de debajo de la wishlist.

   30-08-2026 (2): la estimacion del caso 2 usa el TOPE de la horquilla del bucket ("1-2
   semanas" -> hoy + 14 dias); si cae en fin de semana, corre al lunes.

   30-08-2026 (3) CAJA DE ENTREGA AGRUPADA (redisenio opcion A): place() construye una caja
   gris .ew-deliv-box con hasta 3 lineas: (a) el aviso de inventario SOLO en su variante de
   pocas unidades (data-inventory-quantity <= data-inventory-threshold; la variante generica
   "Compra ahora y recibelo en X" sigue oculta porque duplica al Get it by), (b) este badge,
   y (c) el bloque de texto de envios gratis del template, domesticado (se detecta por su
   texto en ES/EN/NL, fuera de las pestanias, y se muda dentro de la caja). Los estilos de la
   caja estan al final de assets/section-product.css.

   05-oct-2026 (ficha opcion B): si la cuadricula de datos trae el hueco [data-ew-kf-deliv]
   (snippets/ew-key-facts.liquid, casilla ENTREGA Y ENVIO), el plazo y el aviso de pocas
   unidades van ahi y NO se crea la caja gris. La linea de envio gratis la coloca
   assets/ew-ficha.js en [data-ew-kf-ship]. Ademas: fecha y horquilla en FR y PT (antes
   caian al espanol porque el mapa de idiomas solo tenia es/en/nl). */
(function () {
  var el = document.querySelector('[data-ew-delivery]');
  if (!el) return;

  var isAsk = el.getAttribute('data-ask') === '1';
  var inStock = el.getAttribute('data-instock') === '1';
  var isoDate = (el.getAttribute('data-date') || '').trim();
  var lead = parseInt(el.getAttribute('data-lead-days'), 10) || 6;
  var locale = el.getAttribute('data-locale') || 'es';
  var bucket = el.getAttribute('data-bucket') || '';
  var stockPrefix = el.getAttribute('data-stock-prefix') || '';
  var estPrefix = el.getAttribute('data-est-prefix') || '';
  var txt = el.querySelector('[data-deliv-txt]');
  var lcMap = { es: 'es-ES', en: 'en-GB', nl: 'nl-NL', fr: 'fr-FR', pt: 'pt-PT', 'pt-PT': 'pt-PT', da: 'da-DK' };
  var lk = locale === 'pt-PT' ? 'pt' : locale;
  var lc = lcMap[locale] || 'es-ES';

  var bucketMap = {
    'entrega inmediata': { en: 'Immediate delivery', nl: 'Direct leverbaar', fr: 'Livraison immédiate', pt: 'Entrega imediata' },
    'menos de 1 semana': { en: 'Less than 1 week', nl: 'Minder dan 1 week', fr: 'Moins d’1 semaine', pt: 'Menos de 1 semana' },
    '1-2 semanas': { en: '1-2 weeks', nl: '1-2 weken', fr: '1-2 semaines', pt: '1-2 semanas' },
    '2-4 semanas': { en: '2-4 weeks', nl: '2-4 weken', fr: '2-4 semaines', pt: '2-4 semanas' },
    '3-4 semanas': { en: '3-4 weeks', nl: '3-4 weken', fr: '3-4 semaines', pt: '3-4 semanas' },
    '4-6 semanas': { en: '4-6 weeks', nl: '4-6 weken', fr: '4-6 semaines', pt: '4-6 semanas' },
    '1-2 meses': { en: '1-2 months', nl: '1-2 maanden', fr: '1-2 mois', pt: '1-2 meses' },
    'mas de 2 meses': { en: 'over 2 months', nl: 'meer dan 2 maanden', fr: 'plus de 2 mois', pt: 'mais de 2 meses' },
    'más de 2 meses': { en: 'over 2 months', nl: 'meer dan 2 maanden', fr: 'plus de 2 mois', pt: 'mais de 2 meses' }
  };

  function translateBucket(b) {
    if (!b || locale === 'es') return b;
    var m = bucketMap[b.toLowerCase()];
    return (m && m[lk]) ? m[lk] : b;
  }

  /* Tope de la horquilla del bucket, en dias naturales. 0 = no hay horquilla que aplicar
     ("entrega inmediata", "mas de 2 meses", vacio o texto libre) -> estimacion de siempre. */
  function bucketMaxDays(b) {
    if (!b) return 0;
    var s = b.toLowerCase();
    if (s.indexOf('inmediat') !== -1 || s.indexOf('immediate') !== -1 || s.indexOf('direct') !== -1) return 0;
    if (/menos de 1 semana|less than 1 week|minder dan 1 week/.test(s)) return 7;
    var m = /(\d+)\s*(?:[-–]|a|tot|to)\s*(\d+)\s*(semana|week|maand|mes|month)/.exec(s);
    if (!m) return 0;
    var n = parseInt(m[2], 10) || 0;
    if (m[3] === 'mes' || m[3] === 'month' || m[3] === 'maand') return n * 30;
    return n * 7;
  }

  /* Construye la caja gris agrupada. Si algo falla, el badge se queda suelto donde Liquid
     lo pinta (el mismo sitio), asi que el peor caso es el aspecto de antes. */
  function place() {
    try {
      var notices = document.querySelectorAll('.product__inventory-notice');
      var slot = document.querySelector('[data-ew-kf-deliv]');
      if (slot) {
        /* 05-oct-2026: casilla ENTREGA Y ENVIO de la cuadricula de datos. */
        for (var a = 0; a < notices.length; a++) notices[a].classList.add('ew-deliv-replaced');
        if (notices.length) {
          var s0 = notices[0];
          var sq = parseInt(s0.getAttribute('data-inventory-quantity'), 10);
          var sth = parseInt(s0.getAttribute('data-inventory-threshold'), 10);
          if (!isNaN(sq) && sq > 0 && !isNaN(sth) && sq <= sth && /\d+\s*(unit|unidad|stuk|eenhe)/i.test(s0.innerText || '')) {
            slot.appendChild(s0);
            s0.classList.remove('ew-deliv-replaced');
            s0.classList.add('ew-deliv-box__stock');
          }
        }
        slot.appendChild(el);
      } else if (notices.length && !document.querySelector('.ew-deliv-box')) {
        var n0 = notices[0];
        var box = document.createElement('div');
        box.className = 'ew-deliv-box';
        n0.parentNode.insertBefore(box, n0);
        for (var i = 0; i < notices.length; i++) notices[i].classList.add('ew-deliv-replaced');
        var q = parseInt(n0.getAttribute('data-inventory-quantity'), 10);
        var th = parseInt(n0.getAttribute('data-inventory-threshold'), 10);
        if (!isNaN(q) && q > 0 && !isNaN(th) && q <= th && /\d+\s*(unit|unidad|stuk|eenhe)/i.test(n0.innerText || '')) {
          box.appendChild(n0);
          n0.classList.remove('ew-deliv-replaced');
          n0.classList.add('ew-deliv-box__stock');
        }
        box.appendChild(el);
        var texts = document.querySelectorAll('.product__text.product__block');
        for (var t = 0; t < texts.length; t++) {
          var node = texts[t];
          if (node.classList.contains('product__inventory-notice')) continue;
          if (node.closest('.product__tab-content') || node.closest('.ew-deliv-box') || node.closest('.ew-gtk')) continue;
          var s = (node.innerText || '').trim();
          if (s.length > 0 && s.length < 130 && /env[ií]os? gratis|free shipping|gratis verzending/i.test(s)) {
            node.classList.add('ew-deliv-box__ship');
            box.appendChild(node);
            break;
          }
        }
      } else if (!notices.length) {
        var anchor = document.querySelector('.product__price');
        if (anchor && anchor.parentNode) {
          if (anchor.nextSibling) anchor.parentNode.insertBefore(el, anchor.nextSibling);
          else anchor.parentNode.appendChild(el);
        }
      }
    } catch (e) {}
    el.hidden = false;
  }

  // (0) proveedor sin fuente de stock -> se consulta por WhatsApp, no se promete plazo
  if (isAsk) {
    var bEl = el.querySelector('[data-deliv-bucket]');
    if (bEl) bEl.textContent = translateBucket(bEl.textContent.trim());
    place();
    return;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) n--; }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString(lc, { weekday: 'long', day: 'numeric', month: 'long' });
  }

  // Parseo manual: new Date('2026-08-14') se interpreta en UTC y en husos negativos cae un dia antes.
  function parseIso(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return isNaN(d.getTime()) ? null : d;
  }

  var shown = false;

  // (1) fecha real del proveedor
  var d = isoDate ? parseIso(isoDate) : null;
  if (d) {
    var hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    if (d >= hoy) {
      if (txt) txt.textContent = (inStock ? stockPrefix : estPrefix) + ' ' + fmt(d);
      if (inStock) el.classList.add('ew-deliv--stock');
      shown = true;
    }
  }

  // (2) con stock y sin fecha -> estimacion: tope de la horquilla del bucket si la hay
  //     (fin de semana -> lunes siguiente); sin horquilla, hoy + N dias laborables.
  if (!shown && inStock) {
    var est;
    var maxDays = bucketMaxDays(bucket);
    if (maxDays > 0) {
      est = new Date();
      est.setDate(est.getDate() + maxDays);
      while (est.getDay() === 0 || est.getDay() === 6) est.setDate(est.getDate() + 1);
    } else {
      est = addBusinessDays(new Date(), lead);
    }
    if (txt) txt.textContent = stockPrefix + ' ' + fmt(est);
    el.classList.add('ew-deliv--stock');
    shown = true;
  }

  // (3) sin stock y sin fecha -> ventana del bucket
  if (!shown) {
    if (!bucket) return;
    if (txt) txt.textContent = estPrefix + ' ' + translateBucket(bucket);
  }

  place();
})();
